import { useRef } from "react";
import { useCallbackOne } from "use-memo-one";

export default function useGetter<T>(value: T): () => T {
  const ref = useRef(value);
  ref.current = value;
  return useCallbackOne(() => ref.current, []);
}
